import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { useDateTimeFormatStore } from "./useDateTimeFormatStore";

export const useDetectDateTimeFormat = () => {
    const location = useLocation();
    const checkAndUpdateFormat = useDateTimeFormatStore(state => state.checkAndUpdateFormat);
    
    useEffect(() => {
        checkAndUpdateFormat();
    }, [location.pathname, checkAndUpdateFormat]);
};